import { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import OneSignal from "react-onesignal";
import useAuth from "./useAuth";

const useUserData = () => {
  const userInfo = useSelector((state: any) => state.userInfo);
  const { getMe } = useAuth();

  // Set user ID in OneSignal
  const setUserId = useCallback(async () => {
    if (!userInfo) return;
    
    try {
      const isSubscribed = await OneSignal.isPushNotificationsEnabled();
      if (isSubscribed) {
        await OneSignal.getExternalUserId(); // Get current ID
        await OneSignal.setExternalUserId(userInfo.id);
      }
    } catch (error) {
      console.error("Failed to set OneSignal user ID", error);
    }
  }, [userInfo]);

  // Initialize OneSignal with user ID
  useEffect(() => {
    if (userInfo) {
      setUserId();
    }
  }, [userInfo, setUserId]);

  return {
    userInfo,
    getMe,
    setUserId
  };
};

export default useUserData; 